<script setup lang="ts">
    import { computed } from 'vue';
    import { Chart as ChartJS, Filler, Legend, LineElement, PointElement, RadarController, RadialLinearScale, Tooltip } from 'chart.js';
    import { Chart } from 'vue-chartjs';
    import { applyChartDefaults } from '@shared/modules/chartjs-defaults';
    import { chartColor } from '@shared/modules/chart-colors';
    import Loading from '@shared/components/Loading.vue';
    import type { DimensionReport } from '../../SurveysTypes.d';

    ChartJS.register(RadarController, RadialLinearScale, LineElement, PointElement, Filler, Legend, Tooltip);
    applyChartDefaults();

    const props = defineProps<{
        report: DimensionReport | null;
        loading: boolean;
    }>();

    const chartData = computed(() => ({
        labels: props.report?.Labels ?? [],
        datasets: [
            {
                data: props.report?.Values ?? [],
                label: $Resources.ChartDimensionLabelAll,
                backgroundColor: chartColor('primary', 0.2),
                borderColor: chartColor('primary'),
                pointBackgroundColor: chartColor('primary'),
                fill: true,
            },
            {
                data: props.report?.FilteredValues ?? [],
                label: $Resources.ChartDimensionLabelSelection,
                backgroundColor: chartColor('secondary', 0.2),
                borderColor: chartColor('secondary'),
                pointBackgroundColor: chartColor('secondary'),
                fill: true,
            },
        ],
    }));

    const chartOptions = {
        maintainAspectRatio: true,
        spanGaps: false,
        elements: {
            line: {
                tension: 0.000001,
            },
        },
        scales: {
            r: {
                pointLabels: { font: { size: 13 } },
                suggestedMin: 0,
                suggestedMax: 100,
            },
        },
    };
</script>

<template>
    <div class="container-fluid m-lg-t">
        <article class="question-card p-relative">
            <Loading :show="loading" loadingStyle="spinner" />

            <div v-if="report" class="h-400">
                <Chart type="radar" :data="chartData" :options="chartOptions" />
            </div>
        </article>
    </div>
</template>
